<template>
    <div class="backdrop" @click="backClick">
    </div>
</template>

<script>
export default {
    methods: {
        backClick(){
            this.$emit('backClicked', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.backdrop{
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100vh;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.7);
}
</style>